import React, { useEffect, useState, useMemo, useCallback } from "react";
import CustomSelect from "../../../../../components/Elements/Select/CustomSelect";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import toast from "react-hot-toast";
import { Button } from "antd";
import CustomDatePicker from "../../../../../components/Elements/CustomDatePicker/CustomDatePicker";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import moment from "moment";

const AssignedForm = ({
  projectId,
  selectedRows,
  assignedFormType,
  selectedRole,
  setSelectedRole,
  formId,
  setFormId,
}) => {
  const [selectedForm, setSelectedForm] = useState(null);
  const [selectedSection, setSelectedSection] = useState([]);

  const [roleList, setRoleList] = useState([]);
  const [formList, setFormList] = useState([]);

  const [sectionList, setSectionList] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [formDataMap, setFormDataMap] = useState([]);

  useEffect(() => {
    const fetchStandardSurveyForms = async () => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARDFORM(projectId),
        });

        if (response?.success) {
          const allForms = response.data;
          setFormDataMap(allForms);

          const list = allForms.map((formData) => ({
            label: formData.title,
            value: formData.title.toLowerCase(),
            formId: formData._id,
          }));
          setFormList(list);
        }
      } catch (error) {
        console.error("Error fetching standard survey forms", error);
      }
    };

    fetchStandardSurveyForms();
  }, [projectId]);

  const fetchSection = useCallback(async (formId) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_SECTION_BY_FORMID(formId),
      });

      if (response?.success) {
        // Map section objects directly
        const sectionOptions = response.data.map((section) => ({
          label: section.name,
          value: section._id,
          sectionId: section.id, // use `section.id` if that's your unique string id
        }));

        setSectionList([
          { label: "Select ALL SECTION", value: "all_section" },
          ...sectionOptions,
        ]);
      }
    } catch (error) {
      console.error("Error fetching sections", error);
    }
  }, []);

  const handleSelectForm = useCallback(
    (value) => {
      const selected = formList.find((form) => form.value === value);
      setSelectedForm(value);
      setSelectedSection([]);
      setSelectedRole(null);

      if (selected?.formId) {
        setFormId(selected.formId);
        fetchSection(selected.formId);
      }

      // Update roleList based on selected form
      const selectedFormData = formDataMap.find(
        (form) => form.title.toLowerCase() === value,
      );

      const roles = selectedFormData?.role_type || [];
      setRoleList(
        roles.map((role) => ({
          label: role,
          value: role.toLowerCase(),
        })),
      );
    },
    [formList, fetchSection, formDataMap],
  );

  const handleSelectSection = useCallback(
    (value) => {
      if (value.includes("all_section")) {
        setSelectedSection(sectionList.map((section) => section.value));
      } else {
        setSelectedSection(value);
      }
    },
    [sectionList],
  );

  const postAssignedForm = useCallback(
    async (formData) => {
      try {
        const response = await postApi({
          apiUrl:
            assignedFormType === "standard"
              ? API_URLS.CREATE_STANDARD_ASSIGN_FORM
              : API_URLS.CREATE_DYNAMIC_ASSIGN_FORM,
          data: formData,
        });
        if (response?.success) {
          toast.success(`${assignedFormType} form Assigned successfully`);
        } else {
          toast.error(`${response?.message}`);
        }
      } catch (error) {
        console.error("Error assigning form", error);
        toast.error("Something went wrong");
      }
    },
    [assignedFormType],
  );

  const handleApply = useCallback(() => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("Please select at least one user.");
      return;
    }
    if (!endDate) {
      alert("Please select end date");
      return;
    }

    const currentDate = moment().format("YYYY-MM-DD");

    const newAssignedFormData = {
      projectId: projectId,
      templateId: formId,
      user: selectedRows.map((user) => {
        const userSections =
          selectedSection.length === 1 ? selectedSection[0] : selectedSection;

        return {
          id: user.key,
          sections: userSections,
          endDate,
          allotmentDate: currentDate,
          status:
            assignedFormType === "standard"
              ? user.status?.toLowerCase()
              : user.status?.toLowerCase() === "active"
                ? "Assigned"
                : user.status?.toLowerCase(),
        };
      }),
      role: selectedRole?.toLowerCase(),
    };
    console.log("row is ", selectedRows);
    console.log("selected Section", selectedSection);
    console.log("Data is", newAssignedFormData);
    postAssignedForm(newAssignedFormData);
  }, [
    selectedRows,
    selectedSection,
    sectionList,
    projectId,
    formId,
    endDate,
    postAssignedForm,
  ]);

  const handleReset = useCallback(() => {
    setSelectedForm(null);
    setSelectedSection([]);
    setSelectedRole(null);
    setEndDate("");
    setRoleList([]);
    setFormId(null);
    setSectionList([]);
  }, []);

  return (
    <div>
      <div className="flex gap-10 items-start">
        <div className="w-full">
          <h4 className="text-[#06513D] text-sm mt-2">SELECT FORM</h4>
          <CustomSelect
            options={formList}
            mode="single"
            placeholder="--None--"
            height="40px"
            value={selectedForm}
            onChange={handleSelectForm}
            loading={formList.length === 0}
          />
          <div className="my-2">
            <h4 className="text-[#06513D] text-sm mt-2">SELECT ROLE</h4>
            <CustomSelect
              options={roleList}
              mode="single"
              placeholder="--None--"
              height="40px"
              value={selectedRole}
              onChange={setSelectedRole}
              loading={roleList.length === 0}
              disabled={!selectedForm}
            />
          </div>
        </div>
        <div className="w-full">
          <h4 className="text-[#06513D] text-sm mt-2">SELECT SECTION</h4>
          <CustomSelect
            options={sectionList}
            mode="multiple"
            height="40px"
            placeholder="Select Section"
            value={selectedSection}
            onChange={handleSelectSection}
            disabled={!selectedForm}
            loading={sectionList.length === 0}
          />
          <div className="my-2">
            <h4 className="text-[#06513D] text-sm mt-2">End Date</h4>
            <CustomDatePicker
              value={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              placeholder="Select End Date"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-5 bg-white">
        <Button
          type="primary"
          style={{
            color: "#06513D",
            background: "#e7fefe",
            border: "2px solid #06513D",
            height: "50px",
            width: "120px",
            borderRadius: "10px",
          }}
          className="text-[16px]"
          onClick={handleReset}
        >
          Reset
        </Button>
        <CustomButton
          buttonType="primary"
          variant="ok"
          buttonText="Apply"
          className="text-[16px] w-36 h-12"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default AssignedForm;
